import locale from '@landing/common/consts/locale'
import format from './format'

export default function dateToBirthStr(date, pattern = 'yyyy-MM-dd') {
  return format(date, pattern, { locale })
}
